import "./logoColor.scss";
import React from "react";
import { ReactComponent as BarNegative } from "./bar_negative.svg";
import { ReactComponent as BasicLine } from "./basic_line.svg";
import { ReactComponent as ColumnBar } from "./column_bar.svg";
import { ReactComponent as ColumnNegative } from "./column_negative.svg";
import { ReactComponent as ColumnStacked } from "./column_stacked.svg";
import { ReactComponent as DataGrid } from "./data_grid.svg";
import { ReactComponent as Description } from "./description.svg";
import { ReactComponent as DistributionScatter } from "./distribution_scatter.svg";
import { ReactComponent as DistributionScatterEsg } from "./distribution_scatter_esg.svg";
import { ReactComponent as Donut } from "./donut.svg";
import { ReactComponent as DonutEsg } from "./donut_esg.svg";
import { ReactComponent as HorizontalBar } from "./horizontal_bar.svg";
import { ReactComponent as JCurve } from "./JCurve.svg";
import { ReactComponent as KPI } from "./kpi.svg";
import { ReactComponent as LineMissingPoint } from "./line_missing_point.svg";
import { ReactComponent as Map } from "./map.svg";
import { ReactComponent as Preqin } from "./preqin.svg";
import { ReactComponent as Scatter } from "./scatter.svg";
import { ReactComponent as ScatterEsg } from "./scatter_esg.svg";
import { ReactComponent as StackedBarEsg } from "./stacked_bar_esg.svg";
import { ReactComponent as StackedEqualBarEsg } from "./stacked_equal_bar_esg.svg";
export const iconList = {
    barNegative: React.createElement(BarNegative, null),
    basicLine: React.createElement(BasicLine, null),
    columnBar: React.createElement(ColumnBar, null),
    columnNegative: React.createElement(ColumnNegative, null),
    columnStacked: React.createElement(ColumnStacked, null),
    dataGrid: React.createElement(DataGrid, null),
    description: React.createElement(Description, null),
    distributionScatter: React.createElement(DistributionScatter, null),
    distributionScatterEsg: React.createElement(DistributionScatterEsg, null),
    donut: React.createElement(Donut, null),
    donutEsg: React.createElement(DonutEsg, null),
    horizontalBar: React.createElement(HorizontalBar, null),
    jCurve: React.createElement(JCurve, null),
    kpi: React.createElement(KPI, null),
    lineMissingPoint: React.createElement(LineMissingPoint, null),
    map: React.createElement(Map, null),
    preqin: React.createElement(Preqin, null),
    scatter: React.createElement(Scatter, null),
    scatterEsg: React.createElement(ScatterEsg, null),
    stackedBarEsg: React.createElement(StackedBarEsg, null),
    stackedEqualBarEsg: React.createElement(StackedEqualBarEsg, null)
};
export const InsWidgetIcons = (props) => iconList[props.src] ?? React.createElement(React.Fragment, null);
